import { Link } from "react-router-dom";
import { L, imgOf, useFetch, useTitle } from "../lib";
import { PageHeader, SampleTag, Empty, Reveal, ArtImage } from "../ui";

export default function Remembering() {
  useTitle("Remembering Louise");
  const { data } = useFetch("/stories");
  return (
    <div data-testid="remembering-page">
      <PageHeader eyebrow="Remembering Louise" title="Stories, tributes and small moments"
        intro="Words from the people who knew her. Each memory is shared in the contributor's own name." />
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="flex flex-wrap gap-3 items-center justify-between border-y border-lou-line py-6">
          <p className="text-sm text-lou-soft max-w-md">Have a story of your own? Write a sentence or a few pages, and add photographs if you like.</p>
          <Link to={L("/share")} className="lou-btn" data-testid="remembering-share-cta">Share a memory</Link>
        </div>
        {data && data.length === 0 && <Empty testid="stories-empty">The first memories will appear here.</Empty>}
        <div className="mt-6">
          {(data || []).map((s) => (
            <Reveal key={s.id}>
              <article className="py-12 border-b border-lou-line" data-testid={`story-${s.id}`}>
                <SampleTag show={s.is_sample} />
                {s.title && <h2 className="font-lou text-3xl font-light mt-2">{s.title}</h2>}
                <p className="mt-4 text-base sm:text-lg leading-relaxed text-lou-ink/85 whitespace-pre-line">{s.body}</p>
                {s.media_ids?.length > 0 && (
                  <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 gap-3">
                    {s.media_ids.map((m, i) => (
                      <figure key={m}><ArtImage src={imgOf({ media_id: m })} alt={s.image_captions?.[i] || `Photograph shared with ${s.title || "this memory"}`} />
                        {s.image_captions?.[i] && <figcaption className="text-xs text-lou-soft mt-1.5">{s.image_captions[i]}</figcaption>}</figure>
                    ))}
                  </div>
                )}
                <footer className="mt-6 text-sm flex flex-wrap gap-x-3 gap-y-1 text-lou-soft">
                  <span className="text-lou-ink" data-testid={`story-author-${s.id}`}>{s.display_name}</span>
                  {s.relationship && <span>{s.relationship}</span>}
                  {s.date_text && <span>· {s.date_text}</span>}
                  {s.location && <span>· {s.location}</span>}
                  {s.source === "family" && <span className="text-lou-sage">· From the family</span>}
                </footer>
              </article>
            </Reveal>
          ))}
        </div>
        <p className="text-xs text-lou-soft mt-10">
          Something here should be corrected or removed? <Link to={L("/correction")} className="underline hover:text-lou-clay" data-testid="stories-correction-link">Let the family know</Link>.
        </p>
      </div>
    </div>
  );
}
